export default "/_next/static/assets/tsa-pre_cce8f11ae4db40e0524c3ab3c31f8ffc.png";